import {
  getReferenceDataById,
  getReferenceDataByValue,
} from '../../functions/get-reference-data-by-id';
import { IReferenceData } from '../../interfaces/form/reference-data.model';
import { ParentsInfo } from '../../interfaces/student';

export class EditContactResponseModel {
  adultId: string;
  firstName: string;
  middeName: string;
  lastName: string;
  relationship: IReferenceData;
  authorizationCode: IReferenceData;

  homePhone: string;
  workPhone: string;
  cellPhone: string;
  email: string;

  spokenLanguage: IReferenceData;
  writtenLanguage: IReferenceData;

  streetName: string;
  streetNumber: string;
  apartmentNo: string;
  borough: IReferenceData;

  city: string;
  state: IReferenceData;
  zip: string;

  residesWithStudent: string;

  constructor(
    data: ParentsInfo,
    refernceData: Record<string, IReferenceData[]>
  ) {
    // Basic Information
    this.adultId = data?.adultId;
    this.firstName = data?.firstName;
    this.middeName = data?.middleName;
    this.lastName = data?.lastName;
    this.relationship = getReferenceDataById(
      data?.relationship,
      refernceData?.relationship
    );
    this.authorizationCode = getReferenceDataByValue(
      data?.authorizationCode,
      refernceData?.redAlert
    );

    // Language
    this.spokenLanguage = getReferenceDataById(
      data?.preferredSpokenLang,
      refernceData?.language
    );

    this.writtenLanguage = getReferenceDataById(
      data?.preferredWrittenLang,
      refernceData?.language
    );

    // Communication
    this.homePhone = data?.homePhone;
    this.workPhone = data?.workPhone;
    this.cellPhone = data?.cellPhone;
    this.email = data?.emailAddress;

    // Housing Information
    this.streetNumber = data?.address?.streetNumber;
    this.streetName = data?.address?.streetName;
    this.apartmentNo = data?.address?.apartmentNo;

    this.borough = getReferenceDataById(
      Number(data?.address?.borough),
      refernceData?.borough
    );

    this.state = getReferenceDataById(
      Number(data?.address?.state),
      refernceData?.state
    );

    this.city = data?.address?.city;
    this.zip = data?.address?.zipCode;

    this.residesWithStudent = data?.residesWithStudent;
  }
  readonly id: string = '';
}
